import { useTracking } from 'react-tracking';
import { Grid } from '@simplywallst/ui-core';
import UndervaluedIcon from '@assets/images/companyReport/next-steps-undervalued.svg';
import GrowthIcon from '@assets/images/companyReport/next-steps-growth.svg';
import PastPerformanceIcon from '@assets/images/companyReport/next-steps-past-performance.svg';
import HealthyIcon from '@assets/images/companyReport/next-steps-healthy.svg';
import DividendIcon from '@assets/images/companyReport/next-steps-dividend.svg';
import {
  DiscoverArrowIcon,
  DiscoverArrowIconWrapper,
  DiscoverHighlightedText,
  DiscoverIconWrapper,
  DiscoverMore,
  DiscoverText,
} from './styled';

interface RouterLinkAction {
  type: string;
  payload?: any;
}

interface Props {
  link: string | RouterLinkAction;
  industry: string;
  section: 'valuation' | 'future' | 'past' | 'health' | 'dividend';
  market?: string;
}

const NextSteps = ({ link, industry, section, market }: Props) => {
  const discoverText = {
    valuation: 'Potentially undervalued companies',
    future: 'High growth companies',
    past: 'Strong past performing companies',
    health: 'Healthy companies',
    dividend: 'Strong dividend paying companies',
  };
  const { trackEvent } = useTracking();

  return (
    <DiscoverMore
      data-cy-id={`discover-more-${section}`}
      to={link}
      onClick={() =>
        trackEvent({
          action: 'click',
          modifier: 'grid',
        })
      }
    >
      <Grid
        templateColumns="0.5fr 1fr 0.3fr"
        templateColumnsSm="0.5fr 3fr 0.5fr"
        templateColumnsMd="0.5fr 3fr 0.5fr"
      >
        <DiscoverIconWrapper>
          {section === 'valuation' && <UndervaluedIcon />}
          {section === 'future' && <GrowthIcon />}
          {section === 'past' && <PastPerformanceIcon />}
          {section === 'health' && <HealthyIcon />}
          {section === 'dividend' && <DividendIcon />}
        </DiscoverIconWrapper>
        <DiscoverText>
          <div>
            <DiscoverHighlightedText>
              <strong>{discoverText[section]}</strong>
            </DiscoverHighlightedText>
            {section === 'dividend' && typeof market !== 'undefined'
              ? ` in the ${market} market.`
              : ` in the ${industry} industry.`}
          </div>
        </DiscoverText>
        <DiscoverArrowIconWrapper>
          <DiscoverArrowIcon />
        </DiscoverArrowIconWrapper>
      </Grid>
    </DiscoverMore>
  );
};

export default NextSteps;
